// This is the contact us page

import ContactUsComponent from "../NonMVPComponents/ContactUsComponent";
const ContactUs = () => {
  return (
    <div>
      <ContactUsComponent />
    </div>
  );
};

export default ContactUs;
